import React, {useState,useEffect} from 'react'

import { WiCelsius } from "react-icons/wi";

import {images} from '../../constants'
//import { getCurrentData } from '../../actions/currentData';
import{getCurrentData2} from '../../actions/currentData2'

import './WeatherDetails.scss'
import { useSelector,useDispatch } from 'react-redux';

const WeatherDetails = () => {
  
  
  const{currentData,time} = useSelector((state)=>state.currentData);
  const {locationData} = useSelector((state)=>state.locationData);
  const [locData, setLocData] = useState({});
 
 // locData!==null?const[place]=locData['0']?.display_name?.split(','):'UnknownPlace';
  //console.log(place)
  //const locData = JSON.parse(localStorage.getItem('profile1'));
  const desc = currentData.main!==undefined?currentData?.weather[0]?.description:'';
  //const desc = currentData?.weather[0]?.description;
  const fav = currentData.weather!==undefined?currentData?.weather[0]?.icon:'';
  const sunrise = currentData.main!==undefined?currentData?.sys.sunrise:0 ;
  const sunset = currentData.main!==undefined?currentData?.sys.sunset:0 ;
  //console.log(currentData)
  
  const climate = ['rain','cloud','thunder','clear','haze'];

  const setPlace = ()=>{
    if (Object.keys(locData).length>0){
     // console.log("this is"+locData)
      const [place] = locData['0']?.display_name?.split(',');
      return locData['0']?.display_name
    }
    return 'Location Not Found'
    
  }
  //console.log(time);

  const changeFavicon = ()=>{
    if (fav.length>0){
      document.getElementById('favicon').href = `https://openweathermap.org/img/w/${fav}.png`
    }

  }

  const changeImage =()=>{
    
    for(let c in climate){
      
        let d = climate[c];
        if(desc!==undefined){
           if(desc.match('(?='+d+'=?)')!==null && time!==null) {
             if(time>=sunset || time<sunrise) document.body.style.backgroundImage = `url(${images[d+'Night']})`
          
        
             else  document.body.style.backgroundImage = `url(${images[d+'Morning']})`
             return
          
        
           }
           else {document.body.style.backgroundImage = 'none'
           document.body.style.backgroundColor='rgba(0,0,0,0.5)'
           }
          
        } 
         

        
    }
  }

 
  const dispatch = useDispatch();
  
  
  useEffect(() => {
    const locData = JSON.parse(localStorage.getItem('profile1'));
   // console.log(locData)
    locData!==null?setLocData(locData):setLocData({})
    locData!==null?(Object.keys(locData).length>0?dispatch(getCurrentData2('',locData['0'].lat,locData['0'].lon)):alert('Location Not Found, Please enter a location')):alert('Please enter a location')
    
    

    
    changeImage();
    changeFavicon();
    
    
  }, [locationData])

  

  
  
  
//   const rain = 'clearNight' ;
//   const GlobalStyle = createGlobalStyle`
//   body {
    
//     background-image:url(${images[rain]});
//     font-family:var(--font-base);
//   }
// `
  return (
    <>
    {currentData.main!==undefined && (
      <>
    <div className="container">
      <div className="app__weatherDetails app__flex">
        <div className="app__weatherDetails-main app__flex">
            <div className="place">
                <p>{setPlace()}</p>
            </div>
            <div className="icon">
              <img src={`https://openweathermap.org/img/w/${currentData?.weather[0]?.icon}.png`} alt='weathericon'/>
            </div>
            <div className="app__weatherDetails-main-temp">

                <h2 className='h-text'>
                  {`${Math.ceil(currentData?.main?.temp)}`}<WiCelsius/>
                </h2>

            </div>
            <div className="app__weatherDetails-main-details">
                  <p>Feels Like </p><h1>{Math.ceil(currentData?.main?.feels_like)}<WiCelsius/></h1>
                  {/*  */}
                  {currentData.weather!==undefined&&
                  (<p>{currentData?.weather[0]?.description.replace(/\b(\w)/g, s => s.toUpperCase())}</p>)}
            </div>
            <div className="test">
              <h1>{changeImage()}</h1>
            </div>

        </div>
      </div>
      </div>
      {/* <GlobalStyle/> */}
      </>
      
    )}
    </> 
  )
}

export default WeatherDetails